<section class="vc-admin-detail">
  <app-admin-page-header
    titleKey="ADMIN.PATIENTS.DETAIL.MANAGE.TITLE"
    descriptionKey="ADMIN.PATIENTS.DETAIL.MANAGE.DESCRIPTION"
    [showBack]="true"
    [backLink]="backLink"
    [backQueryParams]="listQueryParams"
    contextLabelKey="COMMON.NAME"
    [contextValue]="patient?.fullName || patient?.name || ''"
  ></app-admin-page-header>

  <nav class="vc-admin-detail__tabs">
      <a
        class="vc-admin-detail__tab"
        [class.active]="activeTab === 'profile'"
        [routerLink]="[baseRoute, 'profile']"
        [queryParams]="listQueryParams"
      >
        <i class="fas fa-user"></i>
        <span>{{ 'COMMON.PERSONAL_DATA' | translate }}</span>
      </a>
      <a
        class="vc-admin-detail__tab"
        [class.active]="activeTab === 'metadata'"
        [routerLink]="[baseRoute, 'metadata']"
        [queryParams]="listQueryParams"
      >
        <i class="fas fa-database"></i>
        <span>{{ 'PATIENT.OTHER_DATA' | translate }}</span>
      </a>
      <a
        class="vc-admin-detail__tab"
        [class.active]="activeTab === 'sites'"
        [routerLink]="[baseRoute, 'sites']"
        [queryParams]="listQueryParams"
      >
        <i class="fas fa-clinic-medical"></i>
        <span>{{ 'PATIENT.CLINICS' | translate }}</span>
      </a>
      <a
        class="vc-admin-detail__tab"
        [class.active]="activeTab === 'history'"
        [routerLink]="[baseRoute, 'history']"
        [queryParams]="listQueryParams"
      >
        <i class="fas fa-file-medical"></i>
        <span>{{ 'PATIENT.CLINICAL_HISTORY' | translate }}</span>
      </a>
      <a
        class="vc-admin-detail__tab"
        [class.active]="activeTab === 'appointments'"
        [routerLink]="[baseRoute, 'appointments']"
        [queryParams]="listQueryParams"
      >
        <i class="fas fa-calendar-check"></i>
        <span>{{ 'COMMON.APPOINTMENTS' | translate }}</span>
      </a>
      <a
        class="vc-admin-detail__tab"
        [class.active]="activeTab === 'treatments'"
        [routerLink]="[baseRoute, 'treatments']"
        [queryParams]="listQueryParams"
      >
        <i class="fas fa-notes-medical"></i>
        <span>{{ 'COMMON.TREATMENTS' | translate }}</span>
      </a>
  </nav>

  <div class="vc-admin-detail__content">
    @if (loading) {
      <app-admin-state-panel
        mode="loading"
        titleKey="COMMON.LOADING"
        descriptionKey="ADMIN.PATIENTS.DETAIL.LOADING"
      ></app-admin-state-panel>
    } @else if (hasError || !patient) {
      <app-admin-state-panel
        mode="error"
        titleKey="COMMON.ERROR"
        descriptionKey="ADMIN.PATIENTS.DETAIL.ERROR"
        [showRetry]="true"
        (retry)="load()"
      ></app-admin-state-panel>
    } @else if (activeTab === 'profile') {
      <app-admin-form-layout
        titleKey="ADMIN.PATIENTS.DETAIL.PROFILE_TITLE"
        descriptionKey="ADMIN.PATIENTS.DETAIL.PROFILE_DESCRIPTION"
      >
        <app-form-patient [payload]="patient" [showIntro]="false" [exclude]="['remarks']"></app-form-patient>
      </app-admin-form-layout>
    } @else if (activeTab === 'metadata') {
      <app-admin-form-layout
        titleKey="PATIENT.OTHER_DATA"
        descriptionKey="ADMIN.PATIENTS.METADATA.TITLE"
      >
        <app-form-patient-metadata [payload]="patient"></app-form-patient-metadata>
      </app-admin-form-layout>
    } @else if (activeTab === 'sites') {
      <app-admin-form-layout
        titleKey="PATIENT.CLINICS"
        descriptionKey="ADMIN.SITES.TITLE"
      >
        <app-form-patient-sites [payload]="patient"></app-form-patient-sites>
      </app-admin-form-layout>
    } @else if (activeTab === 'history') {
      <app-admin-form-layout
        titleKey="PATIENT.CLINICAL_HISTORY"
        descriptionKey="ADMIN.PATIENTS.DETAIL.HISTORY_DESCRIPTION"
      >
        <app-form-patient [payload]="patient" [showIntro]="false" [view]="'history'"></app-form-patient>
      </app-admin-form-layout>
    } @else if (activeTab === 'appointments') {
      <app-admin-form-layout
        titleKey="ADMIN.PATIENTS.DETAIL.APPOINTMENTS_TITLE"
        descriptionKey="ADMIN.PATIENTS.DETAIL.APPOINTMENTS_DESCRIPTION"
      >
        <app-table-patients-appointments [patient]="patient"></app-table-patients-appointments>
      </app-admin-form-layout>
    } @else {
      <app-admin-form-layout
        titleKey="ADMIN.PATIENTS.DETAIL.TREATMENTS_TITLE"
        descriptionKey="ADMIN.PATIENTS.DETAIL.TREATMENTS_DESCRIPTION"
      >
        <app-table-treatments
          [patient]="patient"
          [treatments]="patientTreatments"
          [adminReadonly]="true"
        ></app-table-treatments>
      </app-admin-form-layout>
    }
  </div>
</section>
